export default __webpack_public_path__ + "static/media/embla.c13b1975.png";